import Swiper from 'swiper/swiper-bundle';
if (global) global.Swiper = Swiper
